import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import {
  InfiniteScrollCustomEvent,
  IonButton,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  EmptyResultComponent,
  InfiniteScrollHeaderComponent,
  SkeletonCardInprogressComponent,
  SpinnerLoadingComponent,
  type IInfiniteScrollHeaderConfig,
} from '@okcargo-apps/layout-ionic';
import { AccountService } from '../../account';
import { FreightAvailableCardGoToListCtaComponent } from '../../freight-available/freight-available-card-go-to-list-cta/freight-available-card-go-to-list-cta.component';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { FreightCarrierStoreService } from '../freight-carrier-store.service';
import { FreightCarrierInprogressCardComponent } from '../freight-carrier-inprogress-card/freight-carrier-inprogress-card.component';

@Component({
  selector: 'lib-freight-carrier-inprogress-list',
  templateUrl: './freight-carrier-inprogress-list.component.html',
  styleUrls: ['./freight-carrier-inprogress-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FreightCarrierInprogressCardComponent,
    EmptyResultComponent,
    FreightAvailableCardGoToListCtaComponent,
    InfiniteScrollHeaderComponent,
    IonButton,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    TranslateModule,
    SkeletonCardInprogressComponent,
    SpinnerLoadingComponent,
  ],
})
export class FreightCarrierInprogressListComponent {
  private readonly freightCarrierStoreService = inject(FreightCarrierStoreService);
  private readonly accountService = inject(AccountService);
  private readonly translateService = inject(TranslateService);

  protected readonly vm = this.freightCarrierStoreService.inProgressList;

  protected readonly hasViewMarketCapability = computed(() =>
    this.accountService.account().capabilities.includes(ECapabilities.VIEW_MARKET),
  );

  protected readonly headerConfig = computed<IInfiniteScrollHeaderConfig>(() => {
    const currentVm = this.vm();

    return {
      text: this.translateService.instant('freight.list.item_count', { count: currentVm.totalElements }),
      lastUpdated: currentVm.lastLoadedAt,
      staleMessage: currentVm.isStale ? this.translateService.instant('general.stale_data') : undefined,
      refreshButton: currentVm.isStale
        ? {
            label: this.translateService.instant('general.refresh'),
            action: () => this.onRefreshUser(),
          }
        : undefined,
    };
  });

  protected onIonInfinite(event: InfiniteScrollCustomEvent): void {
    this.freightCarrierStoreService.loadNextInProgressPage();
    event.target.complete();
  }

  protected onRetry(): void {
    this.freightCarrierStoreService.retryInProgress();
  }

  protected onRefreshUser(): void {
    this.freightCarrierStoreService.reloadInProgressList('user');
  }
}
